import Option from '@/modules/common/models/option/option.ts';

export default class ProjectOption extends Option<number> {
  constructor(response: any) {
    super(response, 'P_ID', 'Название', 'Активен');
  }
}
